/** Набор Unicode-эмодзи для пикера и автодополнения: категории, ключевые слова для поиска. */
export interface EmojiEntry {
  char: string
  keys: string
}

export interface EmojiGroup {
  id: string
  label: string
  items: EmojiEntry[]
}

const e = (char: string, keys: string): EmojiEntry => ({ char, keys })

export const EMOJI_GROUPS: EmojiGroup[] = [
  {
    id: 'smileys',
    label: 'Смайлы',
    items: [
      e('😀', 'grin улыбка smile'), e('😃', 'smiley улыбка'), e('😄', 'smile радость'), e('😁', 'beam зубы'), e('😆', 'laughing смех'), e('😅', 'sweat смех пот'),
      e('🤣', 'rofl ржу'), e('😂', 'joy слёзы смех'), e('🙂', 'slight улыбка'), e('🙃', 'upside перевёрнутый'), e('😉', 'wink подмигивание'), e('😊', 'blush смущение'),
      e('😇', 'innocent ангел'), e('🥰', 'hearts влюблён'), e('😍', 'heart_eyes влюблён глаза'), e('🤩', 'star_struck звёзды'), e('😘', 'kiss поцелуй'), e('😋', 'yum вкусно'),
      e('😛', 'tongue язык'), e('😜', 'wink_tongue язык'), e('🤪', 'zany безумный'), e('🤔', 'thinking думаю'), e('🤫', 'shush тихо'), e('🤨', 'raised_eyebrow бровь'),
      e('😐', 'neutral нейтрально'), e('😑', 'expressionless'), e('😶', 'no_mouth'), e('🙄', 'rolling_eyes закатил'), e('😏', 'smirk ухмылка'), e('😒', 'unamused'),
      e('😬', 'grimacing гримаса'), e('🤥', 'lying врун'), e('😌', 'relieved спокойно'), e('😔', 'pensive грусть'), e('😪', 'sleepy сонный'), e('🤤', 'drooling слюни'),
      e('😴', 'sleeping сплю'), e('😷', 'mask маска'), e('🤒', 'thermometer болею'), e('🤕', 'bandage'), e('🤢', 'nauseated тошнит'), e('🤮', 'vomiting'),
      e('🤧', 'sneezing чихаю'), e('🥵', 'hot жарко'), e('🥶', 'cold холодно'), e('🥴', 'woozy'), e('😵', 'dizzy'), e('🤯', 'exploding взрыв мозга'),
      e('🤠', 'cowboy ковбой'), e('🥳', 'partying праздник'), e('😎', 'sunglasses крутой'), e('🤓', 'nerd ботан'), e('🧐', 'monocle'), e('😕', 'confused'),
      e('😟', 'worried'), e('🙁', 'frown'), e('😮', 'open_mouth'), e('😯', 'hushed'), e('😲', 'astonished'), e('😳', 'flushed'),
      e('🥺', 'pleading умоляю'), e('😦', 'frowning'), e('😧', 'anguished'), e('😨', 'fearful страх'), e('😰', 'anxious'), e('😥', 'sad'),
      e('😢', 'cry плачу'), e('😭', 'sob рыдаю'), e('😱', 'scream ужас'), e('😖', 'confounded'), e('😣', 'persevere'), e('😞', 'disappointed'),
      e('😓', 'downcast'), e('😩', 'weary'), e('😫', 'tired устал'), e('🥱', 'yawning зевок'), e('😤', 'triumph'), e('😡', 'rage злой'),
      e('😠', 'angry злость'), e('🤬', 'cursing мат'), e('😈', 'smiling_imp чёрт'), e('👿', 'imp'), e('💀', 'skull череп'), e('☠️', 'skull_crossbones'),
      e('💩', 'poop какашка'), e('🤡', 'clown клоун'), e('👹', 'ogre'), e('👻', 'ghost призрак'), e('👽', 'alien инопланетянин'), e('🤖', 'robot робот'),
      e('😺', 'cat_smile'), e('😻', 'cat_heart'), e('🙈', 'see_no_evil'), e('🙉', 'hear_no_evil'), e('🙊', 'speak_no_evil'),
    ],
  },
  {
    id: 'gestures',
    label: 'Жесты и люди',
    items: [
      e('👋', 'wave привет'), e('🤚', 'raised_back'), e('✋', 'hand ладонь'), e('🖖', 'vulcan'), e('👌', 'ok'), e('🤌', 'pinched'), e('✌️', 'victory'),
      e('🤞', 'crossed_fingers удачи'), e('🤟', 'love_you'), e('🤘', 'metal рок'), e('🤙', 'call_me'), e('👈', 'left'), e('👉', 'right'), e('👆', 'up'),
      e('👇', 'down'), e('☝️', 'index'), e('👍', 'thumbsup +1 лайк да'), e('👎', 'thumbsdown -1 нет'), e('✊', 'fist кулак'), e('👊', 'punch'), e('🤛', 'left_fist'),
      e('🤜', 'right_fist'), e('👏', 'clap аплодисменты'), e('🙌', 'raised_hands ура'), e('🤝', 'handshake рукопожатие'), e('🙏', 'pray прошу спасибо'), e('💪', 'muscle сила'),
      e('🧠', 'brain мозг'), e('👀', 'eyes глаза'), e('👁️', 'eye'), e('👄', 'lips'), e('❤️‍🔥', 'heart_fire'), e('💋', 'kiss_mark'),
      e('👶', 'baby'), e('🧒', 'child'), e('👦', 'boy'), e('👧', 'girl'), e('🧑', 'person'), e('👨', 'man'), e('👩', 'woman'), e('🧓', 'older'),
      e('👮', 'police'), e('🕵️', 'detective'), e('💂', 'guard'), e('👷', 'construction'), e('🤴', 'prince'), e('👸', 'princess'), e('🧙', 'mage маг'),
      e('🧛', 'vampire'), e('🧟', 'zombie'), e('🦸', 'superhero'), e('🎅', 'santa дед мороз'), e('🤷', 'shrug пожимаю'), e('🤦', 'facepalm рукалицо'),
      e('💃', 'dancer'), e('🕺', 'dancing'), e('🧘', 'yoga'), e('🏃', 'running'), e('🚶', 'walking'),
    ],
  },
  {
    id: 'animals',
    label: 'Животные и природа',
    items: [
      e('🐶', 'dog собака'), e('🐱', 'cat кот'), e('🐭', 'mouse мышь'), e('🐹', 'hamster'), e('🐰', 'rabbit заяц'), e('🦊', 'fox лиса'), e('🐻', 'bear медведь'),
      e('🐼', 'panda'), e('🐨', 'koala'), e('🐯', 'tiger тигр'), e('🦁', 'lion лев'), e('🐮', 'cow корова'), e('🐷', 'pig свинья'), e('🐸', 'frog лягушка'),
      e('🐵', 'monkey обезьяна'), e('🐔', 'chicken'), e('🐧', 'penguin пингвин'), e('🐦', 'bird птица'), e('🦆', 'duck утка'), e('🦅', 'eagle орёл'), e('🦉', 'owl сова'),
      e('🐺', 'wolf волк'), e('🐴', 'horse лошадь'), e('🦄', 'unicorn единорог'), e('🐝', 'bee пчела'), e('🐛', 'bug'), e('🦋', 'butterfly бабочка'), e('🐌', 'snail'),
      e('🐢', 'turtle черепаха'), e('🐍', 'snake змея'), e('🦖', 't-rex динозавр'), e('🐙', 'octopus'), e('🦀', 'crab'), e('🐬', 'dolphin'), e('🐳', 'whale кит'),
      e('🐟', 'fish рыба'), e('🌸', 'blossom'), e('🌹', 'rose роза'), e('🌻', 'sunflower'), e('🌲', 'tree ель'), e('🌵', 'cactus'), e('🍀', 'clover клевер'),
      e('🍁', 'maple'), e('🌍', 'earth земля'), e('🌙', 'moon луна'), e('⭐', 'star звезда'), e('🌟', 'glowing_star'), e('⚡', 'zap молния'), e('🔥', 'fire огонь'),
      e('🌈', 'rainbow радуга'), e('☀️', 'sun солнце'), e('☁️', 'cloud'), e('❄️', 'snowflake снег'), e('☔', 'umbrella дождь'), e('🌊', 'wave волна'),
    ],
  },
  {
    id: 'food',
    label: 'Еда и напитки',
    items: [
      e('🍎', 'apple яблоко'), e('🍌', 'banana'), e('🍉', 'watermelon арбуз'), e('🍇', 'grapes'), e('🍓', 'strawberry клубника'), e('🍒', 'cherries'), e('🍑', 'peach'),
      e('🥝', 'kiwi'), e('🍅', 'tomato'), e('🥑', 'avocado'), e('🥕', 'carrot'), e('🌽', 'corn'), e('🥔', 'potato картошка'), e('🍞', 'bread хлеб'),
      e('🧀', 'cheese сыр'), e('🍖', 'meat мясо'), e('🍗', 'chicken_leg'), e('🥓', 'bacon'), e('🍔', 'burger бургер'), e('🍟', 'fries'), e('🍕', 'pizza пицца'),
      e('🌭', 'hotdog'), e('🥪', 'sandwich'), e('🌮', 'taco'), e('🥗', 'salad'), e('🍜', 'noodles'), e('🍣', 'sushi суши'), e('🥟', 'dumpling пельмени'),
      e('🍦', 'ice_cream мороженое'), e('🍩', 'donut пончик'), e('🍪', 'cookie печенье'), e('🎂', 'cake торт'), e('🍫', 'chocolate шоколад'), e('🍬', 'candy'),
      e('☕', 'coffee кофе'), e('🍵', 'tea чай'), e('🧃', 'juice'), e('🥤', 'cup'), e('🍺', 'beer пиво'), e('🍻', 'beers'), e('🍷', 'wine вино'), e('🥂', 'champagne'),
    ],
  },
  {
    id: 'activity',
    label: 'Занятия и предметы',
    items: [
      e('⚽', 'soccer футбол'), e('🏀', 'basketball'), e('🏈', 'football'), e('🎾', 'tennis'), e('🏐', 'volleyball'), e('🎱', 'billiards'), e('🏓', 'ping_pong'),
      e('🥊', 'boxing'), e('🎯', 'dart цель'), e('🎮', 'game геймпад игра'), e('🕹️', 'joystick'), e('🎲', 'dice кубик'), e('🧩', 'puzzle'), e('🎸', 'guitar'),
      e('🎹', 'piano'), e('🎤', 'mic микрофон'), e('🎧', 'headphones наушники'), e('🎬', 'clapper кино'), e('🎨', 'art'), e('🏆', 'trophy кубок победа'), e('🥇', 'gold первое'),
      e('🥈', 'silver'), e('🥉', 'bronze'), e('🎁', 'gift подарок'), e('🎉', 'tada праздник ура'), e('🎊', 'confetti'), e('🎈', 'balloon'), e('🎄', 'christmas ёлка'),
      e('💻', 'laptop ноутбук'), e('🖥️', 'desktop компьютер'), e('⌨️', 'keyboard'), e('🖱️', 'mouse_pc'), e('📱', 'phone телефон'), e('📷', 'camera'), e('🔋', 'battery'),
      e('💡', 'bulb идея'), e('🔧', 'wrench'), e('🔨', 'hammer'), e('⚙️', 'gear'), e('🔒', 'lock'), e('🔑', 'key ключ'), e('📌', 'pin'), e('📎', 'clip'),
      e('📝', 'memo'), e('📚', 'books книги'), e('📅', 'calendar'), e('⏰', 'alarm'), e('💰', 'money деньги'), e('💎', 'gem'), e('🚀', 'rocket ракета'),
      e('🚗', 'car машина'), e('✈️', 'airplane самолёт'), e('🏠', 'house дом'), e('🗺️', 'map'),
    ],
  },
  {
    id: 'symbols',
    label: 'Символы',
    items: [
      e('❤️', 'heart сердце любовь'), e('🧡', 'orange_heart'), e('💛', 'yellow_heart'), e('💚', 'green_heart'), e('💙', 'blue_heart'), e('💜', 'purple_heart'), e('🖤', 'black_heart'),
      e('🤍', 'white_heart'), e('💔', 'broken_heart'), e('💕', 'two_hearts'), e('💯', '100 сто'), e('💢', 'anger'), e('💥', 'boom'), e('💫', 'dizzy_star'),
      e('💤', 'zzz'), e('✅', 'check галочка да'), e('❌', 'x нет крест'), e('❓', 'question вопрос'), e('❗', 'exclamation'), e('⭕', 'o'), e('🚫', 'no_entry'),
      e('⚠️', 'warning'), e('🔞', '18'), e('♻️', 'recycle'), e('✨', 'sparkles'), e('🔔', 'bell'), e('🔕', 'no_bell'), e('🎵', 'note'), e('🎶', 'notes'),
      e('➕', 'plus'), e('➖', 'minus'), e('➗', 'divide'), e('✖️', 'multiply'), e('♾️', 'infinity'), e('🆗', 'ok_button'), e('🆕', 'new'), e('🆒', 'cool'),
      e('🔝', 'top'), e('🔜', 'soon'), e('🔙', 'back'), e('▶️', 'play'), e('⏸️', 'pause'), e('⏹️', 'stop'), e('🔁', 'repeat'), e('🇷🇺', 'ru россия флаг'),
    ],
  },
]

const RECENT_KEY = 'klichat.emoji.recent'

export function recentEmoji(): string[] {
  try {
    return JSON.parse(localStorage.getItem(RECENT_KEY) ?? '[]') as string[]
  } catch {
    return []
  }
}

export function rememberEmoji(token: string) {
  try {
    const list = [token, ...recentEmoji().filter((t) => t !== token)].slice(0, 24)
    localStorage.setItem(RECENT_KEY, JSON.stringify(list))
  } catch {
    /* приватный режим */
  }
}

/** Поиск по ключевым словам Unicode-эмодзи. */
export function searchUnicode(query: string, limit = 24): EmojiEntry[] {
  const q = query.trim().toLowerCase()
  if (!q) return []
  const out: EmojiEntry[] = []
  for (const g of EMOJI_GROUPS) {
    for (const it of g.items) {
      if (it.keys.toLowerCase().includes(q)) {
        out.push(it)
        if (out.length >= limit) return out
      }
    }
  }
  return out
}

/** Токен кастомного эмодзи в тексте сообщения. */
export function customEmojiToken(e: { id: string; name: string; animated?: boolean }): string {
  return `<${e.animated ? 'a' : ''}:${e.name}:${e.id}>`
}

/**
 * Вставка в текст на месте курсора: добавляет пробел слева, если его там нет, и справа —
 * чтобы следующее слово не прилипло. Возвращает новый текст и куда поставить курсор.
 */
export function insertToken(value: string, start: number, end: number, token: string): { text: string; caret: number } {
  const before = value.slice(0, start)
  const after = value.slice(end)
  const lead = before && !/\s$/.test(before) ? ' ' : ''
  const tail = after.startsWith(' ') ? '' : ' '
  return { text: `${before}${lead}${token}${tail}${after}`, caret: before.length + lead.length + token.length + tail.length }
}

/** Ключ реакции для API: символ Unicode или name:id. */
export function reactionKey(e: { id: string | null; name: string }): string {
  return e.id ? `${e.name}:${e.id}` : e.name
}
